import React, { ReactNode, useState } from 'react';

type PrintContextValues = {
  isPrinting: boolean;
  setIsPrinting: (isPrinting: boolean) => void;
};

type PrintContextProps = {
  children: ReactNode;
};

const PrintContext = React.createContext<PrintContextValues>(null);

export const PrintProvider = ({ children }: PrintContextProps) => {
  const [isPrinting, setIsPrinting] = useState(false);

  return (
    <PrintContext.Provider
      value={{
        isPrinting,
        setIsPrinting,
      }}
    >
      {children}
    </PrintContext.Provider>
  );
};

export default PrintContext;
